<!-- src/layouts/DefaultLayout.vue -->
<template>
    <div class="app">
      <Navbar />
      <div class="app-container">
        <Sidebar />
        <div class="app-content-wrapper">
          <router-view />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/layouts/Navbar.vue';
  import Sidebar from '@/layouts/Sidebar.vue';
  
  export default {
    name: 'DefaultLayout',
    components: {
      Navbar,
      Sidebar
    }
  };
  </script>
  
  <style scoped>
  /* Add your styles here */

  .app-content-wrapper {
    flex: 1;
  }
  </style>
  